export enum PlanoEnum {
    Pro = 1,
    Unlimited = 2,
    Enterprise = 3
}
